// extracted by mini-css-extract-plugin
module.exports = {"summary":"BudgetSummary_summary__FZQaS"};